import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { setDealersModalFilter } from 'modules/dealers/actions';
import { getFilters } from 'modules/dealers/selectors/modalSelect';
import { getAllGroupsSelect } from 'modules/groups/selectors';
import Select from 'ui/base/Select';

const FIELD_NAMES = { label: 'name', value: 'id' };

const GroupSelect = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const filters = useSelector(getFilters);
  const groups = useSelector(getAllGroupsSelect);

  const value = filters.groupIds;

  const handleOnChange = React.useCallback(groupIds => {
    dispatch(setDealersModalFilter({ groupIds }));
  }, [dispatch]);

  return (
    <Select
      withSearch
      value={value}
      mode="multiple"
      options={groups}
      fieldNames={FIELD_NAMES}
      onChange={handleOnChange}
      placeholder={intl.formatMessage({ id: 'group', defaultMessage: 'Group' })}
    />
  );
};

export default GroupSelect;
